'use strict'; // also used by node

module.exports = function contentChecksumPackagePathForLocale (locale) {
  return locale ? `/generated/content-checksums-${locale}.js` : '/generated/content-checksums-base.js';
};



// WEBPACK FOOTER //
// ./lib/rlink-router/contentChecksumPackagePathForLocale.js